export const LOADING_STATE = 'LOADING_STATE';
export const PREVENT_LOADING = 'PREVENT_LOADING';
